import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'cigna-dialog-evernorth-help-secure',
  templateUrl: './dialog-evernorth-help-secure.component.html',
  styleUrls: ['./dialog-evernorth-help-secure.component.css'],
})
export class DialogEvernorthHelpSecureComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogEvernorthHelpSecureComponent>,
  ) {}

  close() {
    this.dialogRef.close();
  }
}
